import * as React from 'react'
import ByTagsSelector from '../../by_tags_selector'
import { Tag } from './types'

const { I18n } = window as any

type FiltersProps = {
  nameFilter: string
  onNameFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  selectedTags: Tag[]
  onTagsChange: (tags: Tag[]) => void
  allTags: Tag[]
}

export default function Filters(props: FiltersProps) {
  const { nameFilter, onNameFilterChange, selectedTags, onTagsChange, allTags } = props

  return (
    <div className="row mb-3">
      <div className="col-6">
        <input
          type="text"
          className="form-control"
          placeholder={I18n.t('campaigns.others.filter_by_name')}
          value={nameFilter}
          onChange={onNameFilterChange}
        />
      </div>
      <div className="col-6">
        <ByTagsSelector
          items={allTags}
          selectTag={onTagsChange}
          value={selectedTags}
        />
      </div>
    </div>
  )
}
